<template>
	<div class="cont">
		<div>
			<div id="flipbook" class="flipbook">
				<div v-for="(item,index) in imagesList" :key="index" :style="`
          background:#ffffff url(${item.picture_image}) no-repeat 100% 100%; background-size:100% 100%`">
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	//turn.js
	import {
		pdf_detail
	} from '@/api/api.js'
	import turn from '../../utils/turn.js'
	export default {
		name: 'Home',
		data() {
			return {
				id:0,
				imagesList: []
			}
		},

		mounted() {
			let that = this
			  this.id = this.$route.query.id
			setTimeout(function() {
				that.onTurn();
			}, 2500)
			this.detail(this.id)
		},
		methods: {
			onTurn() {
				this.$nextTick(() => {
					$("#flipbook").turn({
						autoCenter: true,
						height: 800,
						width:1200,
						display: 'single', //显示：single=单页，double=双页，默认双页
					});
				})



			},
			//月刊详情，图片列表
			detail(id) {
				let data = {
					id: id
				}
				pdf_detail(data).then(res => {
					if (res.code == 1) {
						let allPages = res.data.cn_pdf_arr
						this.imagesList = allPages.map(item => ({
							"picture_image": item
						}))
					}
				}).catch(err => {});

			},

		},
	}
</script>
<style scoped>
	* {
		margin: 0;
		padding: 0;
	}

	.cont {
		width: 100vw;
		height: 100vh;
		overflow: hidden;
	}

	.flipbook {
		margin: 50px auto !important;
		box-shadow: 0 0 0 10px #f3f3f3;

	}
</style>
